/**
 * Free Shipping Bar Settings - Refactored
 *
 * Main container component that orchestrates sub-components.
 * Single Responsibility: Coordinate settings sections and manage state
 */
import { Stack, Container } from '@mantine/core';
import { useFreeShippingBarSettings } from '../../hooks/useFreeShippingBarSettings';
import { useSettingsSave } from '../../hooks/useSettingsSave';
import { GeneralSettings } from './GeneralSettings';
import { DisplayOptions } from './DisplayOptions';
import { StylingSettings } from './StylingSettings';

export const FreeShippingBarSettingsRefactored = () => {
  const { settings, setSettings, loading: settingsLoading } = useFreeShippingBarSettings(
    window.revotyFreeShippingBarSettings || {}
  );

  const handleSuccess = () => {
    // Settings saved successfully
  };

  const handleError = (error) => {
    // Handle save error
  };

  const { saveSettings, loading: saveLoading } = useSettingsSave(handleSuccess, handleError);

  const handleSave = () => {
    saveSettings(settings);
  };

  if (settingsLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Container size="xl" p={0}>
      <Stack gap="xl">
        <GeneralSettings
          settings={settings}
          onSettingsChange={setSettings}
        />

        <DisplayOptions
          settings={settings}
          onSettingsChange={setSettings}
        />

        <StylingSettings
          settings={settings}
          onSettingsChange={setSettings}
          onSave={handleSave}
          loading={saveLoading}
        />
      </Stack>
    </Container>
  );
};
